export const AUTH_EXPIRED_EVENT = 'auth-expired'
export const FORCE_LOGOUT_EVENT = 'auth-force-logout'

export type AuthExpiredEventDetail = {
  context?: string
  reason?: string
}

export type ForceLogoutEventDetail = {
  reason?: string
}

export function dispatchAuthExpired(detail: AuthExpiredEventDetail = {}): void {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT, { detail }))
}

export function dispatchForceLogout(detail: ForceLogoutEventDetail = {}): void {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(new CustomEvent(FORCE_LOGOUT_EVENT, { detail }))
}
